import {
  conversationFilterSchema,
  type ConversationFilter,
  type Role,
} from '@chatapp-inbox/shared';

/** Parâmetro de busca da URL que guarda a aba ativa (sobrevive à navegação entre conversas). */
export const FILTER_PARAM = 'filtro';

/** Parâmetro de busca da URL que guarda o que a pessoa procura na lista (junto da aba, para recarregar e voltar). */
export const SEARCH_PARAM = 'busca';
/** O mesmo limite do servidor (`q` até 100 caracteres). */
export const SEARCH_MAX = 100;

/** Texto digitado/URL → busca limpa: espaços repetidos viram um, pontas aparadas, até o limite. Vazio = sem busca. */
export function parseSearch(raw: string | null | undefined): string {
  return (raw ?? '').replace(/\s+/g, ' ').trim().slice(0, SEARCH_MAX).trim();
}

export const FILTER_TABS: readonly { filter: ConversationFilter; label: string }[] = [
  { filter: 'mine', label: 'Minhas' },
  { filter: 'unassigned', label: 'Não atribuídas' },
  { filter: 'all', label: 'Todas' },
  { filter: 'closed', label: 'Encerradas' },
];

/** Valor da URL → filtro válido, ou null se ausente/inválido (quem chama aplica o padrão). */
export function parseFilter(raw: string | null): ConversationFilter | null {
  const parsed = conversationFilterSchema.safeParse(raw);
  return parsed.success ? parsed.data : null;
}

/** Quem administra quer o panorama geral; o atendente começa pelo que é dele. */
export function defaultFilter(role: Role): ConversationFilter {
  return role === 'admin' ? 'all' : 'mine';
}

/** Mensagem do estado vazio de cada aba (a de "Minhas" ainda ganha uma dica na tela). */
export const EMPTY_MESSAGES: Record<ConversationFilter, string> = {
  mine: 'Nenhuma conversa atribuída a você.',
  unassigned: 'Nenhuma conversa aguardando atendimento.',
  all: 'Nenhuma conversa por aqui ainda.',
  closed: 'Nenhuma conversa encerrada.',
};

/** Estado vazio de uma busca: diz o que foi procurado. */
export const searchEmptyMessage = (query: string): string =>
  `Nenhuma conversa encontrada para “${query}”.`;

/**
 * Dica do estado vazio de uma busca: a busca vale só dentro da aba escolhida, e as abas de trabalho
 * incluem as conversas encerradas nela (a aba "Encerradas" só as encerradas).
 */
export const searchEmptyHint = (filter: ConversationFilter): string =>
  filter === 'all'
    ? 'Confira o nome ou o telefone.'
    : filter === 'closed'
      ? 'A busca vale só entre as conversas encerradas. Veja também “Todas”.'
      : 'A busca vale só dentro desta aba. Veja também “Todas”.';

/** Anúncio (leitor de tela) do que a busca achou; "30+" quando ainda há mais para carregar. */
export const searchFoundText = (count: number, more: boolean): string =>
  `${count}${more ? '+' : ''} ${count === 1 && !more ? 'conversa encontrada' : 'conversas encontradas'}.`;
